import React from 'react';

import { DomainObject } from 'types';
import { ApiRoute, GridBodyType, PageKey } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';

import { EadFields } from './ead-fields';
import { EadActionButtons } from './ead-action-buttons';

export const eadConfig: GridEntityConfig<never, DomainObject> = {
  id: 'ead',
  title: 'Ead',
  getLabel: (item) => item.title ?? '',
  getId: (item) => item.id,
  apiRoute: ApiRoute.EAD,
  listApi: '',
  pageKey: PageKey.EAD,
  ActionButtons: EadActionButtons,
  icon: 'description',
  bodyComponents: { [GridBodyType.DETAIL]: EadFields },
};

export const eadGridConfig: any[] = [eadConfig];

export const EadGrid = () => <Grid gridConfig={eadGridConfig} />;
